import { useMutation, useQueryClient } from "@tanstack/vue-query";
import Meeting from "@/services/meeting";
import type { RescheduleMeeting } from "@/dtos/Meeting.dto";

export function useRescheduleMeeting() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: RescheduleMeeting) => {
      const result = await Meeting.rescheduleMeeting(data);
      if (!result.data.status) {
        throw new Error(result.data.msg || "Failed to reschedule meeting");
      }
      return result.data.data;
    },
    onSuccess: (updatedMeeting) => {
      // Patch cached meeting lists immediately so any open table/modal reflects the
      // reschedule right away, without waiting for a background refetch.
      queryClient.setQueriesData({ queryKey: ["meetings"] }, (old: any) => {
        if (!old?.data) return old;
        return {
          ...old,
          data: old.data.map((m: any) =>
            m.id === updatedMeeting.id ? { ...m, ...updatedMeeting } : m
          ),
        };
      });
      queryClient.invalidateQueries({ queryKey: ["meetings"] });
      queryClient.invalidateQueries({ queryKey: ["meetingStats"] });
    },
  });
}
